/**
 * ドライバースケジュール
 * ドライバー情報
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const search_driver_schedule_driver = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index (context, params) {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/driver_schedules/drivers`, { params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_driver_schedule_driver
